// removed by extract-text-webpack-plugin
module.exports = {"ArticlePreview":"styles__ArticlePreview___1iOxe"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/featuredPosts/styles.css
// module id = hUzy
// module chunks = 3